<template>
  <div>
    <Subheader title="Post a Photo" />

    <div class="app-content-column">
      <div class="card">
        <form class="form" @submit.stop.prevent="submitPhoto">
          <h5>Upload Photos</h5>
          <input ref="resultFiles" class="input" type="file" @change="previewFiles" />
          <div class="button-wrapper is-centered">
            <button class="large-button" :class="{ 'large-button--disabled': !photo }">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

import Photo from '@/services/photos'

export default {
  name: 'NewPhoto',
  components: {
    Subheader,
  },
  data() {
    return {
      files: [],
      photo: null,
      //TODO: need to add in disabled attr to button
      loading: false,
    }
  },
  methods: {
    previewFiles(event) {
      this.photo = event.target.files[0]
    },
    submitPhoto() {
      if (this.photo) {
        let projectId = this.$route.params.projectId

        Photo.api.create(projectId, this.photo).then(() => {
          this.$Alert.alert({
            type: 'success',
            message: `<h2>Photo Submitted</h2>`,
            timeout: 3000,
          })
          this.$router.push({ name: 'Project', params: { projectId: projectId } })
        })
      } else {
        this.$Alert.alert({
          type: 'error',
          message: `<h2>Upload a photo to submit</h2>`,
          timeout: 2000,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}
</style>
